import React from 'react'
import {Button} from './Button'
import {ArrowRight, CalendarIcon, ChevronRight, UsersIcon} from './icons'
import {demoBookingUrl, sectionHref, signupPageHref} from './constants'
import HeroDemo from './heroDemo/HeroDemo'

function HeroV2({homePath = '/'}) {
  return (
    <section className="hlm-hero">
      <div className="hlm-container hlm-hero-inner">
        <a href={sectionHref(homePath, 'features')} className="hlm-hero-pill">
          <span className="hlm-hero-pill-icon">
            <UsersIcon />
          </span>
          Trusted by 15,000+ agents nationwide
          <ChevronRight color="#64748b" />
        </a>
        <h1>Run every listing from one place.</h1>
        <p className="hlm-hero-sub">Win more listings, handle every step without switching tools, and get your sellers the best deal.</p>
        <div id="start" className="hlm-hero-ctas">
          <div className="hlm-hero-cta-row">
            <Button href={signupPageHref} size="lg" className="hlm-btn-hero-primary">
              Start free
              <ArrowRight size={18} stroke={2} />
            </Button>
            <Button href={demoBookingUrl} variant="secondary" size="lg" target="_blank" rel="noopener noreferrer">
              Book a demo
              <CalendarIcon size={18} />
            </Button>
          </div>
          <div className="hlm-hero-caption">14-day free Pro trial · No credit card required</div>
        </div>
      </div>

      <div className="hlm-hero-demo-wrap">
        <HeroDemo />
      </div>
    </section>
  )
}

export default HeroV2
